import {Chip, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {CustomATage} from "../ExternalSourceManagement/ExternalSourceTable";
import {convertDateToTimeString} from "../utils/cert-helper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";

/**
 * @date: 04/29/23
 * @author: Kengcheng Feng <kfeng@max.md>
 * @copy: (C) Copyright 2023 MaxMD Corporation, All Rights Reserved.
 */


const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold',
})
const StyledTableContainer = styled(TableContainer)({
    maxHeight: '600px',
    '& .MuiTableCell-root': {
        paddingLeft: '4px',
        paddingRight: '4px'
    }
})

export default function OrgTypeLogsTable (props) {
    const orgTypeLogs = props.orgTypeLogs;

    return (
        <StyledTableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Data Source</StyledTableCell>
                        <StyledTableCell>Description</StyledTableCell>
                        <StyledTableCell>Data Path</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Imported Record Count</StyledTableCell>
                        <StyledTableCell>Created Time</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Status</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orgTypeLogs && orgTypeLogs.map((log, i) => {
                        return (
                            <TableRow key={i}>
                                <TableCell>{log.datasource}</TableCell>
                                <TableCell>{log.description}</TableCell>
                                <TableCell sx={{ maxWidth: '350px', wordBreak: 'break-all'}}><CustomATage size='14px' path={log.dataPath} /></TableCell>
                                <TableCell sx={{ textAlign: 'center'}}>{log.importedRecordCount}</TableCell>
                                <TableCell>{convertDateToTimeString(log.createdTs)}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    {log.completed ? <Chip variant='outlined' label="COMPLETED" color="success" icon={<CheckCircleIcon/>}/>
                                        : <Chip label="UNCOMPLETED" color="warning" variant='outlined'/>}
                                </TableCell>
                            </TableRow>
                        )
                    })}

                </TableBody>

            </Table>
        </StyledTableContainer>
    )

}